import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Breadcrumbs,
  Button,
  Grid,
  Link,
  SvgIcon,
  Typography,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { PlusCircle as PlusIcon } from 'react-feather';
import LanguageSelector from 'src/components/LanguageSelector';

const useStyles = makeStyles(theme => ({
  root: {},
  actionIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className,
  title,
  fromGlassSearchView, onFileNewGlassClaim, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      alignItems="center"
      container
      justify="space-between"
      spacing={3}
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Grid item>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Box>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Typography variant="body1" color="textPrimary">
                {t('glassClaims')}
              </Typography>
              <Link
                variant="body1"
                color="inherit"
                to="/ExternalClaims/browse-glass-claim"
                component={RouterLink}
              >
                {t('claims')}
              </Link>
            </Breadcrumbs>
            <Typography variant="h3" color="textPrimary" style={{ marginTop: 20 }}>
              {title ?? t('seeTheLatestUpdates')}
            </Typography>
          </Box>
          <LanguageSelector />
        </Box>
      </Grid>
      {fromGlassSearchView && <Grid item>
        <Button
          color="secondary"
          component={RouterLink}
          to="/glass/claim"
          variant="contained"
          onClick={onFileNewGlassClaim}
        >
          <SvgIcon fontSize="small" className={classes.actionIcon}>
            <PlusIcon />
          </SvgIcon>
          {t('fileANewGlassClaim')}
        </Button>
      </Grid>}
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  fromGlassSearchView: PropTypes.bool,
  title: PropTypes.string,
  onFileNewGlassClaim: PropTypes.func
};

export default Header;
